export default __webpack_public_path__ + "static/media/radio-selected.151724a1.svg";